import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { DataService } from './data.service';
import { ISubscriber } from '@core/interfaces/imailing-list';
import { ISubscriberSearchRequest } from '@core/interfaces/isubscriber';
import { getSearchUrl } from './helper.service';

@Injectable({
  providedIn: 'root',
})
export class MailingListService {
  constructor(private dataService: DataService) { }

  getAll(): Observable<any> {
    return this.dataService.get('subscriber');
  }

  getById(id: number): Observable<ISubscriber[]> {
    return this.dataService.get(`subscriber/${id}`);
  }

  search(payload: ISubscriberSearchRequest): Observable<any> {
    const url = getSearchUrl('subscriber/search?', payload);
    return this.dataService.get(url);
  }

  addSubscriber(
    subscriber: ISubscriber,
    message?: string
  ): Observable<boolean> {
    return this.dataService.post('subscriber', subscriber, message);
  }

  update(payload: any, message?: string): Observable<any> {
    return this.dataService.put('subscriber', payload, message);
  }

  deleteSubscriber(id: number, message?: string): Observable<boolean> {
    return this.dataService.delete(`subscriber?id=${id}`, message);
  }
}
